import React from 'react';

import { AddUserPage, UsersPage } from '../../../pages';
import {
  isAdmin,
  isImpExpAdmin,
  isSuperAdmin,
  isTransporter,
} from '../../roles';
import { Routes } from '../../types/route';

export const userRoutes = (useRole: string): Routes[] => {
  return [
    // Super-Admin
    {
      path: '/super-admin/usuarios',
      component: <UsersPage />,
      isAvailable: isSuperAdmin(useRole),
    },
    {
      path: '/super-admin/usuarios/nuevo',
      component: <AddUserPage />,
      isAvailable: isSuperAdmin(useRole),
    },
    // Admin
    {
      path: '/admin/usuarios',
      component: <UsersPage />,
      isAvailable: isAdmin(useRole),
    },
    {
      path: '/admin/usuarios/nuevo',
      component: <AddUserPage />,
      isAvailable: isAdmin(useRole),
    },
    // Transporter
    {
      path: '/transportista/usuarios',
      component: <UsersPage />,
      isAvailable: isTransporter(useRole),
    },
    {
      path: '/transportista/usuarios/nuevo',
      component: <AddUserPage />,
      isAvailable: isTransporter(useRole),
    },
    // Clients
    {
      path: '/cliente/usuarios',
      component: <UsersPage />,
      isAvailable: isImpExpAdmin(useRole),
    },
    {
      path: '/cliente/usuarios/nuevo',
      component: <AddUserPage />,
      isAvailable: isImpExpAdmin(useRole),
    },
  ];
};
